import { jsxs as D, jsx as l, Fragment as _ } from "react/jsx-runtime";
import { useState as m, useEffect as b } from "react";
import { getTimeStringFromDateTime as p, upstreamTzTransform as $ } from "@givebutter/util";
import { faLongArrowRight as R } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as g } from "@fortawesome/react-fontawesome";
import { DatePicker as I } from "../date-picker/DatePicker.js";
import { TimePicker as w } from "./TimePicker.js";
import { DateTime as c } from "luxon";
const C = c.now().plus({ year: 20 }), F = ({
  value: d,
  onChange: f,
  minDate: e,
  maxDate: n,
  isError: x,
  startDateTimeProps: N = {},
  endDateTimeProps: U = {},
  startTimePickerProps: V = {},
  endTimePickerProps: M = {},
  allowRange: T = !0,
  disabled: S = !1,
  disabledStart: A = !1,
  disabledEnd: P = !1,
  startTimeDisabledUntilEnabled: k = !1
}) => {
  const { startInputProps: j = {}, ...z } = N, { startInputProps: L = {}, ...q } = U, [s, E] = m(d ? d[0] : void 0), [o, v] = m(d ? d[1] : void 0), [B, G] = m(), [H, h] = m(), [J, y] = m(), [K, O] = m();
  b(() => {
    if (d) {
      const [t, i] = d;
      E(t), v(T ? i : C);
    }
  }, [d, T]), b(() => {
    if (s && o) {
      const t = s.hasSame(o, "day"), i = e == null ? void 0 : e.hasSame(o, "day");
      if (t) {
        const r = p(s), a = p(o);
        h(a), y(r);
      } else if (!i)
        h(void 0), y(void 0);
      else if (i) {
        const r = c.now().set({ minute: 0 }).plus({ hour: 1 }).toFormat("T");
        y(r);
      }
      if (e) {
        const a = e.hasSame(s, "day") ? p(e) : void 0;
        G(a);
      }
    }
    if (n && o) {
      const i = n.hasSame(o, "day") ? p(n) : void 0;
      O(i);
    }
  }, [o, n, e, s]);
  const Q = (t) => {
    let i = !1, r = t;
    if (t) {
      const { hour: a, minute: u } = s ?? c.now().set({
        hour: e ? e.hour : 0,
        minute: e ? e.minute : 0
      });
      r = t.set({
        hour: a,
        minute: u
      });
    }
    E(r), r && T && o && r > o && (i = !0), f == null || f([r, i ? t : o]);
  }, W = (t) => {
    let i = t;
    if (t) {
      const { hour: r, minute: a } = o ?? c.now().set({
        hour: e ? e.hour : 0,
        minute: e ? e.minute : 0
      });
      i = t.set({ hour: r, minute: a });
    }
    v(i), f == null || f([s, i]);
  }, X = (t) => {
    const { hour: i, minute: r } = c.fromFormat(t, "T");
    let a;
    E((u = c.now()) => (a = u.set({ hour: i, minute: r }), a)), f == null || f([a, o]);
  }, Y = (t) => {
    const { hour: i, minute: r } = c.fromFormat(t, "T");
    let a;
    v((u = c.now()) => (a = u.set({ hour: i, minute: r }), a)), f == null || f([s, a]);
  }, Z = ({ date: t }) => s ? $(t) < s.minus({ day: 1 }) : !1;
  return /* @__PURE__ */ D("div", { className: "flex flex-col items-center justify-start gap-2 xl:!flex-row", children: [
    /* @__PURE__ */ D("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ l(
        I,
        {
          ...z,
          isError: x,
          startInputProps: {
            ...j,
            disabled: S || A
          },
          value: s,
          onChange: (t) => Q(t),
          minDate: e,
          maxDate: n
        }
      ),
      /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
        w,
        {
          cutoffAfter: H,
          cutoffUntil: k ? B : void 0,
          value: s ? p(s) : void 0,
          onValueChange: X,
          disabled: S || A,
          timezoneAbbr: s ? s.offsetNameShort : void 0,
          ...V
        }
      ) })
    ] }),
    T && /* @__PURE__ */ D(_, { children: [
      /* @__PURE__ */ l(g, { icon: R }),
      /* @__PURE__ */ D("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ l(
          I,
          {
            ...q,
            isError: x,
            startInputProps: {
              ...L,
              disabled: S || P
            },
            value: o,
            onChange: (t) => W(t),
            minDate: e,
            maxDate: n,
            tileDisabled: Z
          }
        ),
        /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
          w,
          {
            cutoffAfter: K,
            cutoffUntil: J,
            value: o ? p(o) : void 0,
            onValueChange: Y,
            disabled: S || P,
            timezoneAbbr: s ? s.offsetNameShort : void 0,
            ...M
          }
        ) })
      ] })
    ] })
  ] });
};
F.displayName = "DateTimePicker";
const ct = F;
export {
  F as DateTimePicker,
  ct as Root
};
